import React, { useState, useEffect } from "react";
import axios from "axios";
import { BaseUrl } from "../App";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const Embed = () => {
    const [showOnLoad, setShowOnLoad] = useState(true);
    const [showOnClick, setShowOnClick] = useState(false);
    const [selectedService, setSelectedService] = useState("");
    const [openNewPage, setOpenNewPage] = useState(false);
    const [showSubItems, setShowSubItems] = useState(false);
    const [generatedEmbedCode, setGeneratedEmbedCode] = useState("");
    const [bgColor, setBgColor] = useState(""); // Default background color (from the backend)
    const [textColor, setTextColor] = useState(""); // Default text color (from the backend)
    const [buttonText, setButtonText] = useState("Book Now");
    const [services, setServices] = useState([]);
     const [loading, setLoading] = useState(false);


    const [successMessage, setSuccessMessage] = useState("")
    const [error, setError] = useState("");

    useEffect(() => {
        fetchServices();
        fetchSettings();
    }, []);

    const fetchServices = async () => {
        setLoading(true);

        try {
            const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
                action: "get_all_services",
                api_key: "1",
            });

            if (response.data.status === "true" && response.data.statuscode === 200) {
                setServices(response.data.response);
            } else {
                console.error("No services found.");
            }
        } catch (error) {
            console.error("Error fetching services:", error);
        } finally {
      setLoading(false);
    }
    };

    // Fetch Color Settings from the Backend
    const fetchSettings = async () => {
        setLoading(true);

        try {
            const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
                action: "get_all_settings",
                api_key: "1",
            });

            if (response.data.status === "true" && response.data.statuscode === 200) {
                const settings = response.data.response;

                // Find the color settings based on option_name
                const secondaryColor = settings.find((setting) => setting.option_name === "ct_secondary_color_admin");
                const textColor = settings.find((setting) => setting.option_name === "ct_text_color_admin");

                // Set the background and text colors if the options are found
                if (secondaryColor) setBgColor(secondaryColor.option_value);
                if (textColor) setTextColor(textColor.option_value);
            } else {
                console.error("No settings found.");
            }
        } catch (error) {
            console.error("Error fetching settings:", error);
        } finally {
      setLoading(false);
    }
    };



    const handleServiceChange = (e) => {
        setSelectedService(e.target.value);
    };

    const handleCheckboxChange = (checkboxId) => {
        if (checkboxId === "checkbox1") {
            setShowSubItems(true);
        } else {
            setShowSubItems(false);
        }
    };

    const embedCode = `
     <div id="Megaclean" class="direct-load" data-url="http://10.27.1.104:3000"></div>
     <script src="http://10.27.1.104:3000" type="text/javascript"></script>
     <script src="http://10.27.1.104:3000" type="text/javascript"></script>`;

    const handleGenerateEmbed = () => {
        const embedCode = `<div id="Megaclean" class="direct-load" data-url=http://10.27.1.104:3000></div><script src="http://10.27.1.104:3000" type="text/javascript"></script><script src="http://10.27.1.104:3000" type="text/javascript"></script>></iframe>`;
        setGeneratedEmbedCode(embedCode);
    };




    return (
        <div className="relative min-h-screen">
        {/* Loading Indicator */}
          {loading && (
               <div className="fixed inset-0 flex items-center justify-center z-50">
                 <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
                   <FadeLoader 
                     height={15}
                     width={5}
                     color="#ffffff"
                     ariaLabel="loading"
                   />
                   <h1 className="mt-1 text-lg text-white">Please wait...</h1>
                 </div>
               </div>
             )}
             
        <main className="container mx-auto px-4 md:px-6 lg:px-8  xl:px-24 py-6 ">
            <div className="space-y-6">
                {/* Section 1 */}
                <div className="bg-white shadow-md p-4 rounded">
                    <h2 className="text-lg font-bold mb-2">
                        <span className="animate-pulse">1.</span> Widget Loading Style
                    </h2>
                    <div className="space-y-2 ml-4">
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4 text-blue-600"
                                id="checkbox2"
                                checked={!showSubItems}
                                onChange={() => handleCheckboxChange("checkbox2")}
                            />
                            <span>Show on page load</span>
                        </label>
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4 text-blue-600"
                                id="checkbox1"
                                checked={showSubItems}
                                onChange={() => handleCheckboxChange("checkbox1")}
                            />
                            <span>Show on a button click</span>
                        </label>

                        {/* Sub-items */}
                        {showSubItems && (
                            <div>
                                <div className="p-3 pb-6 bg-slate-50 rounded shadow-md">
                                    <p className="font-semibold">1.1 Button Position</p>
                                    <label className="flex items-center space-x-2 mb-4">
                                        <input
                                            type="checkbox"
                                            className="form-checkbox h-4 w-4 text-blue-600"
                                            checked={true}
                                        />
                                        <span>Show button on given embed position</span>
                                    </label>

                                    <div className="space-y-4">
                                        <div className="flex flex-col sm:flex-row gap-8">
                                            {/* Background Color */}
                                            <div>
                                                <label htmlFor="bgColor" className="block w-52 text-sm font-medium">
                                                    Background Color
                                                </label>
                                                <input
                                                    type="color"
                                                    id="bgColor"
                                                    value={bgColor}
                                                    onChange={(e) => setBgColor(e.target.value)}
                                                    className="w-52 h-8 border rounded"
                                                />
                                                <p className="mt-2">Color Code: {bgColor}</p>
                                            </div>

                                            {/* Text Color */}
                                            <div>
                                                <label htmlFor="textColor" className="block text-sm font-medium">
                                                    Text Color
                                                </label>
                                                <input
                                                    type="color"
                                                    id="textColor"
                                                    value={textColor}
                                                    onChange={(e) => setTextColor(e.target.value)}
                                                    className="w-52 h-8 border rounded"
                                                />
                                                <p className="mt-2">Color Code: {textColor}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-col sm:flex-row gap-8">
                                            {/* Button Text */}
                                            <div>
                                                <label htmlFor="buttonText" className="block mb-2 text-sm font-medium">
                                                    Button Text
                                                </label>
                                                <input
                                                    type="text"
                                                    id="buttonText"
                                                    value={buttonText}
                                                    onChange={(e) => setButtonText(e.target.value)}
                                                    className="w-52 px-2 py-1 mt-2 border rounded"
                                                    placeholder="Enter button text"
                                                />
                                            </div>

                                            {/* Button Preview */}
                                            <div>
                                                <label className="block text-sm font-medium mb-2">Button Preview</label>
                                                <button
                                                    style={{
                                                        backgroundColor: bgColor,
                                                        color: textColor,
                                                    }}
                                                    className="w-auto font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
                                                >
                                                    {buttonText}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-2 mt-4 bg-slate-50 rounded shadow-md">
                                    <p className="font-semibold">1.2 Behaviour on click of button</p>
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            className="form-checkbox h-4 w-4 text-blue-600"
                                            checked={true}
                                        />
                                        <span>Open widget in a new page</span>
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Section 2 */}
                <div className="bg-white shadow-md p-4 rounded">
                    <h2 className="text-lg font-bold mb-2">02. Get the Embed Code</h2>
                    <textarea
                        readOnly
                        className="w-full p-2 border rounded bg-slate-50 shadow-sm"
                        rows={5}
                        value={embedCode.trim()}
                    />
                    <span>Please Copy above code and paste in your website.</span>
                </div>

                {/* Section 3 */}
                <div className="bg-white shadow-md p-4 rounded">
                    <h2 className="text-lg font-bold mb-2">3. Service Based Embed Code</h2>
                    <select className="block w-40 p-2 border rounded" value={selectedService} onChange={handleServiceChange}>
                        <option value="">Select a service</option>
                        {services.map((service) => (
                            <option key={service.id} value={service.id}>{service.title}</option>
                        ))}
                    </select>

                    <button onClick={handleGenerateEmbed} className="mt-4 px-4 py-2 bg-blue-500 text-white rounded">
                        Generate Embed
                    </button>

                    {generatedEmbedCode && (
                        <div className="mt-4 p-3 bg-gray-100 rounded border">
                            <h3 className="font-semibold mb-2">Generated Embed Code:</h3>
                            <textarea readOnly className="w-full p-2 border rounded bg-white shadow-sm" rows={5} value={generatedEmbedCode} />
                        </div>
                    )}
                </div>
                <span>Please Copy above code and paste in your website.</span>
            </div>
        </main>
        
     
  </div>
    );
};

export default Embed;
